import { takeEvery, all, fork, call, put } from "redux-saga/effects"

// Crypto Redux States
import { UPDATE_SYSTEM_SETTING, GET_SYSTEM_SETTING } from "./actionTypes"

import { settingsApiSuccess, settingsApiFail } from "./actions"

//Include Both Helper File with needed methods
import { updatesettingApi, getSettingApi } from "helpers/backend_helper"

function* updateSetting({ payload: settingId, data }) {
  try {
    const response = yield call(updatesettingApi, settingId, settingId.data)
    yield put(settingsApiSuccess(UPDATE_SYSTEM_SETTING, response))
  } catch (error) {
    yield put(settingsApiFail(UPDATE_SYSTEM_SETTING, error))
  }
}

function* getSettingData() {
  try {
    const response = yield call(getSettingApi)
    yield put(settingsApiSuccess(GET_SYSTEM_SETTING, { ...response.data[0] }))
  } catch (error) {
    console.log("error", error)
    yield put(settingsApiFail(GET_SYSTEM_SETTING, error))
  }
}

function* watchUpdateSetting() {
  yield takeEvery(UPDATE_SYSTEM_SETTING, updateSetting)
}

function* watchGetSettingData() {
  yield takeEvery(GET_SYSTEM_SETTING, getSettingData)
}

function* settingsSaga() {
  yield all([fork(watchUpdateSetting), fork(watchGetSettingData)])
}

export default settingsSaga
